"use client";

import { Chat } from "@/components/chat";
import { DataStreamHandler } from "@/components/data-stream-handler";
import { convertToUIMessages } from "@/lib/utils";
import { DEFAULT_CHAT_MODEL } from "@/lib/ai/models";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { useRouter } from "next/navigation";
import {
  setSaveDbStore,
  setHtmlContentNew,
  setGlobalLoading

} from "@/store/mainSlice";
import { toast } from "sonner";
import { isDocumentType } from "@/lib/dropDownData";

const DynamicPages = ({ screen_id }) => {

  // 🔹 State to store fetched data
  const [chatData, setChatData] = useState(null);
  const [uiMessages, setUiMessages] = useState([]);
  const [savedHtmlUrl, setSavedHtmlUrl] = useState("");
  const [urlData, setUrlData] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch()
  const router = useRouter();
  const { isSavedChanges } = useSelector((state) => state.main)
  useEffect(() => {
    // console.log("Dynamic Page Mounted, checking authToken and userId");
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    if (!token || !userId) {
      router.push("/login"); // redirect if not logged in
      return
    } else {
      setLoading(false); // token exists, show page
    }
    dispatch(setGlobalLoading(false))
  }, [router]);

  let hasShownToast = false;

  const getData = async () => {
    try {
      const baseUrl = process.env.NEXT_PUBLIC_APP_URL_LOCAL || "http://localhost:4700";
      const API_URL = `${baseUrl}/api/website/logs/${screen_id}`;

      const res = await fetch(API_URL, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "0",
        },
      });
      if (!res.ok) {
        const text = await res.text();
        router.replace("/");
        console.error("Failed to fetch logs:", res.status, text);
        return;
      }

      const chatData = await res.json();
      // ✅ Now chatData.user_id is available
      const ownerId = chatData?.user_id?.toString();
      const currentUserId = localStorage.getItem("userId");
      // console.log(currentUserId, "<<<currentUserId", ownerId, "<<<ownerId")

      if (ownerId && ownerId !== currentUserId) {
        if (!hasShownToast) {
          hasShownToast = true;
          toast.error("This chat belongs to another account. You cannot access it.", {
            style: { color: "red" },
            position: "top-center",
            iconTheme: { primary: "red", secondary: "#fff" },
          });
        }
        router.replace("/"); // redirect wherever you want
        return;
      }
      setChatData(chatData);
      const uiMessages = convertToUIMessages(chatData.logs);
      setUiMessages(uiMessages);


      const lastLog = chatData.logs[chatData.logs.length - 1];
      let data = {
        html_file_detail: lastLog.html_file_detail,
        content:lastLog.content,
        is_followup: lastLog.is_followup,
        screen_id: lastLog.screen_id,
        creditUsed: lastLog.creditUsed
      }
      dispatch(setSaveDbStore(data))
      if (lastLog?.html_file_detail) {
        const response = await fetch(lastLog.html_file_detail);
        const htmlContent = await response.text();
        setSavedHtmlUrl(htmlContent);
        dispatch(setHtmlContentNew(htmlContent))
        // console.log("setHtmlContentNew-11")
        setUrlData(lastLog.html_file_detail);
      } else if (isDocumentType(lastLog.chat_type) && lastLog.content) {
        setSavedHtmlUrl(lastLog.content);
        dispatch(setHtmlContentNew(lastLog.content));
        setUrlData("");
      }
    } catch (err) {
      console.error("Error fetching chat data:", err);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    if (!token || !userId) {
      router.push("/login"); // redirect if not logged in
      return;
    }

    if (screen_id) {
      getData();
      // console.log("yyyyyyyyyyyyyyyy", isSavedChanges)
    }
  }, [screen_id]);


  // useEffect(() => {
  //   // console.log(savedHtmlUrl, "savedHtmlUrlsavedHtmlUrlsavedHtmlUrl")

  // }, [savedHtmlUrl])

  if (!chatData) {
    return <div className="flex h-screen items-center justify-center">Loading chat...</div>;
  }


  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      {/* {
        console.log(savedHtmlUrl, "savedHtmlUrl")
      } */}
      <Chat
        id={chatData.id}
        initialMessages={uiMessages}
        initialChatModel={DEFAULT_CHAT_MODEL}
        initialVisibilityType={chatData.visibility || "public"}
        isReadonly={false}
        autoResume={true}
        initialHtmlContent={savedHtmlUrl}
        initialScreenId={screen_id}
        urlData={urlData}
        setSavedHtmlUrl={setSavedHtmlUrl}
        chatData={chatData.logs[0]}
      />
      <DataStreamHandler />
    </>
  );
};

export default DynamicPages;
